"use client";
import { useT } from "@/i18n/useT";
import { useParams } from "next/navigation";

export default function NotFound() {
  const t = useT("routes.notFound");
  const params = useParams();
  const locale = typeof params.locale === "string" ? params.locale : "en";
  return (
    <main className="flex flex-col items-center justify-center min-h-screen px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">{t("title")}</h1>
      <p className="text-lg text-gray-600 mb-6">{t("description")}</p>
      <a href={`/${locale}/`} className="text-blue-600 underline">
        {t("goHome")}
      </a>
    </main>
  );
}
